"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ToolsOperationsFactory = void 0;
const lodash_1 = __importDefault(require("lodash"));
const constants_1 = __importDefault(require("../constants"));
class ToolsOperationsFactory {
    create(group, type, subType, data) {
        const result = {
            actionTime: Date.now(),
            properties: Object.assign(Object.assign(Object.assign({}, data), { group,
                type }), (subType === false ? {} : { subType: !subType ? null : subType })),
        };
        return result;
    }
    template({ type, subType, template, pageId = 0 }) {
        if (!template)
            throw new Error('Unexpected empty template');
        const { type: templateType, subType: templateSubType } = template, templateUntyped = __rest(template, ["type", "subType"]);
        if (!type && templateType)
            type = templateType;
        if (!subType && templateSubType)
            subType = templateSubType;
        if (typeof templateUntyped.pageId !== 'undefined')
            delete templateUntyped.pageId;
        let specific = {};
        if (type === 'radio')
            specific = { type, subType };
        return this.create(constants_1.default.GROUP.TOOLS, type, subType, {
            pageId,
            template: Object.assign(Object.assign({}, templateUntyped), specific),
        });
    }
    content({ type, subType, content, pageId = 0 }) {
        const { type: contentType, subType: contentSubType } = content, contentUntyped = __rest(content, ["type", "subType"]);
        if (!type && contentType)
            type = contentType;
        if (!subType && contentSubType)
            subType = contentSubType;
        if (typeof contentUntyped.pageId !== 'undefined')
            delete contentUntyped.pageId;
        let specific = {};
        if (['signature', 'initials'].indexOf(type) !== -1) {
            specific = { type, subType };
        }
        const data = {
            pageId,
            content: Object.assign(Object.assign({}, contentUntyped), specific),
        };
        return this.create(constants_1.default.GROUP.TOOLS, type, subType, data);
    }
    pages(pages, moreProps = {}) {
        return this.create(constants_1.default.GROUP.TOOLS, constants_1.default.TYPE.PAGES, false, Object.assign({ pages }, moreProps));
    }
    comment(commentData, pageId) {
        const { general } = commentData, rest = __rest(commentData, ["general"]);
        const content = Object.assign(Object.assign({}, general), rest);
        return this.create(constants_1.default.GROUP.TOOLS, constants_1.default.TYPE.COMMENT, constants_1.default.SUB_TYPE.NONE, {
            content,
            pageId,
        });
    }
    attribute(attributeKey, attributeData) {
        return this.create(constants_1.default.GROUP.TOOLS, constants_1.default.TYPE.ATTRIBUTES, attributeKey, {
            content: attributeData,
        });
    }
    accessBusy(accessData, accessLevel, defaults) {
        if (!defaults)
            defaults = {
                timeout: 0,
                location: '',
                message: '',
            };
        const { GROUP, TYPE, ACCESS } = constants_1.default;
        const { timeout, location, message, busyUser } = Object.assign({ timeout: defaults.timeout, location: defaults.location, message: defaults.message }, accessData);
        return this.create(GROUP.DOCUMENT, TYPE.ACCESS, accessLevel || ACCESS.BUSY, {
            timeout,
            location,
            message,
            busyUser,
        });
    }
    accessDenied(accessData) {
        return this.create(constants_1.default.GROUP.DOCUMENT, constants_1.default.TYPE.ACCESS, constants_1.default.ACCESS.DENIED, {
            location: accessData.location,
        });
    }
    // accessOperation(accessData, config = {}) {
    accessOperation(accessData, config) {
        if (!accessData)
            throw new Error('Expected accessData');
        const accessLevel = accessData.subType;
        const defaults = config ? config.busy : undefined;
        if (accessLevel === constants_1.default.ACCESS.DENIED)
            return this.accessDenied(accessData);
        if (this.getAuthAccessIsBusy(accessLevel))
            return this.accessBusy(accessData, accessLevel, defaults);
        return this.create(constants_1.default.GROUP.DOCUMENT, constants_1.default.TYPE.ACCESS, accessLevel, accessData);
    }
    defaultsOperation(editorDefaults) {
        if (!editorDefaults)
            throw new Error('Expected editorDefaults');
        return this.create(constants_1.default.GROUP.EDITOR, constants_1.default.TYPE.DEFAULTS, false, editorDefaults);
    }
    featuresOperation(featuresData) {
        if (!featuresData)
            throw new Error('Expected featuresData');
        return this.create(constants_1.default.GROUP.EDITOR, constants_1.default.TYPE.FEATURES, false, featuresData);
    }
    scenariosOperation(scenariosData) {
        if (!scenariosData)
            throw new Error('Expected scenariosData');
        return this.create(constants_1.default.GROUP.EDITOR, constants_1.default.TYPE.SCENARIOS, false, scenariosData);
    }
    sourceOperation(pdfObject, swfObject) {
        if (!pdfObject)
            throw new Error('Expected pdfObject');
        const opData = {
            pdf: Object.assign({ status: constants_1.default.PDF_STATUS.FINISHED }, pdfObject),
        };
        if (swfObject) {
            opData.swf = Object.assign({ status: constants_1.default.PDF_STATUS.FINISHED }, swfObject);
        }
        return this.create(constants_1.default.GROUP.DOCUMENT, constants_1.default.TYPE.SOURCE, false, opData);
    }
    editorMode(mode, { allowed = true, error, elapsedTime }) {
        const modesList = Object.values(constants_1.default.EDITOR_MODE);
        if (!modesList.includes(mode)) {
            throw new Error(`Wrong mode. Expected one of ${modesList.join()}`);
        }
        return this.create(constants_1.default.GROUP.EDITOR, constants_1.default.TYPE.MODE, mode, {
            allowed,
            error,
            elapsedTime,
        });
    }
    rolesMappingList(mappingArray) {
        return this.create(constants_1.default.GROUP.ROLES, constants_1.default.TYPE.MAPPING, constants_1.default.SUB_TYPE.LIST, {
            mapping: mappingArray,
        });
    }
    initOperations(data) {
        if (!data)
            return { operations: {} };
        const accessOperation = data.access ? this.accessOperation(data.access, data.config) : false;
        const defaultsOperation = data.editorDefaults ? this.defaultsOperation(data.editorDefaults) : false;
        const featuresOperation = data.editorFeatures ? this.featuresOperation(data.editorFeatures) : false;
        const scenariosOperation = data.editorScenarios ? this.scenariosOperation(data.editorScenarios) : false;
        const sourceOperation = data.pdfObject ? this.sourceOperation(data.pdfObject) : false;
        const accessLevel = lodash_1.default.get(accessOperation, 'properties.subType', false);
        return Object.assign({ operations: Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, (accessOperation ? { accessOperation } : {})), (defaultsOperation ? { defaultsOperation } : {})), (featuresOperation ? { featuresOperation } : {})), (scenariosOperation ? { scenariosOperation } : {})), (sourceOperation ? { sourceOperation } : {})) }, (accessLevel ? { accessLevel } : {}));
    }
    getAuthAccessIsBusy(accessLevel) {
        return [constants_1.default.ACCESS.BUSY, constants_1.default.ACCESS.STRONG_BUSY, constants_1.default.ACCESS.SWITCH_ENV].includes(accessLevel);
    }
}
exports.ToolsOperationsFactory = ToolsOperationsFactory;
//# sourceMappingURL=index.js.map